import { render, staticRenderFns } from "./newScriptManagementFour.vue?vue&type=template&id=06ebe2b3&scoped=true"
import script from "./newScriptManagementFour.vue?vue&type=script&lang=js"
export * from "./newScriptManagementFour.vue?vue&type=script&lang=js"
import style0 from "./newScriptManagementFour.vue?vue&type=style&index=0&id=06ebe2b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebe2b3",
  null
  
)

export default component.exports